import _regeneratorRuntime from 'babel-runtime/regenerator';
import _asyncToGenerator from 'babel-runtime/helpers/asyncToGenerator';

import _ from 'lodash';
import { fetchAdvertiserInfo as _fetchAdvertiserInfo } from '@/api/advertiser/manage';
import TableList from '@/components/TableList';

export default {
  name: 'invoice',

  components: {
    TableList: TableList
  },

  props: {
    advId: {
      type: [Number, String],
      required: true
    },

    invoiceId: {
      type: [Number, String],
      required: true
    }
  },

  data: function data() {
    return {
      loading: false,

      invoices: [],
      tableConfig: {},
      columnConfig: [{
        label: 'Invoice Name',
        prop: 'name'
      }, {
        label: 'Name of Business',
        prop: 'company',
        width: 170
      }, {
        label: 'Address',
        prop: 'address',
        width: 170
      }, {
        slot: 'select'
      }]
    };
  },


  computed: {
    currentInvoice: {
      get: function get() {
        return this.invoiceId;
      },
      set: function set(val) {
        this.$emit('change', this.invoices.find(function (item) {
          return item.id === val;
        }));
      }
    }
  },

  watch: {
    advId: function advId(val) {
      if (!val) this.$emit('change', '');
      this.fetchAdvertiserInfo(val);
    }
  },

  mounted: function mounted() {
    this.fetchAdvertiserInfo(this.advId);
  },


  methods: {
    fetchAdvertiserInfo: function fetchAdvertiserInfo(id) {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var res;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (id) {
                  _context.next = 3;
                  break;
                }

                _this.invoices = [];
                return _context.abrupt('return');

              case 3:
                _context.prev = 3;

                _this.loading = true;
                _context.next = 7;
                return _fetchAdvertiserInfo({ id: id });

              case 7:
                res = _context.sent;

                _this.invoices = _.get(res, 'data.data.info.invoices');
                // 默认选中第一个invoice
                if (_this.invoices && _this.invoices.length > 0) {
                  _this.$emit('change', _this.invoices[0]);
                }
                _this.loading = false;
                _context.next = 17;
                break;

              case 13:
                _context.prev = 13;
                _context.t0 = _context['catch'](3);

                console.log(_context.t0);
                _this.loading = false;

              case 17:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this, [[3, 13]]);
      }))();
    }
  }
};